import React from 'react';
import { IonPage, IonContent } from '@ionic/react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ServiceCard from '@/components/ServiceCard';
import CTASection from '@/components/CTASection';
import AnimatedSection from '@/components/AnimatedSection';
import { services } from '@/data/services';
import styles from './Services.module.scss';

const Services: React.FC = () => {
  return (
    <IonPage id="services-page">
      <IonContent fullscreen scrollY scrollEvents={true}>
        <div className="page-wrapper">
          <Navbar />

          {/* Hero */}
          <section className={`${styles.hero} dark-section`}>
            <div className="container">
              <AnimatedSection>
                <span className={styles.eyebrow}>Our Services</span>
              </AnimatedSection>
              <AnimatedSection delay={0.08}>
                <h1 className={styles.heroTitle}>
                  Technology, Design &{' '}<span className={styles.gradient}>Digital Growth</span> Services
                </h1>
              </AnimatedSection>
              <AnimatedSection delay={0.16}>
                <p className={styles.heroSub}>
                  From websites and mobile applications to AI, design, marketing, SEO, hosting, and brand identity —
                  we bring technology and creativity together under one roof.
                </p>
              </AnimatedSection>
            </div>
          </section>

          {/* Services grid */}
          <section className={`section ${styles.servicesSection} light-section`} id="services-grid">
            {/* Subtle background decoration */}
            <div className={styles.decorDotGrid} />
            <div className={styles.decorCircle} />

            <div className="container">
              <AnimatedSection>
                <div className={styles.intro}>
                  <span className={styles.introEyebrow}>What We Build</span>
                  <h2 className={styles.introTitle}>
                    Technology designed<br />around real goals.
                  </h2>
                  <div className={styles.introAccent} />
                </div>
              </AnimatedSection>

              <div className={styles.grid}>
                {services.map((service, i) => (
                  <ServiceCard key={service.id} service={service} index={i} delay={i * 0.05} />
                ))}
              </div>
            </div>
          </section>

          <CTASection
            eyebrow="Ready to Start?"
            title="Let's Discuss Your Project"
            subtitle="Tell us what you're building — we'll tell you how we can help."
            primaryLabel="Get in Touch"
            primaryTo="/contact"
            secondaryLabel="View Our Process"
            secondaryTo="/process"
          />

          <Footer />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Services;
